export default __webpack_public_path__ + "static/media/question_19.86762da8.png";